/* ── Nav ─────────────────────────── */
const nav = document.getElementById('nav');
let lastY = 0;
window.addEventListener('scroll', () => {
  const y = window.scrollY;
  nav.classList.toggle('dark', y > 50);
  if (y > 80) {
    nav.classList.toggle('nav-hidden', y > lastY);
  } else {
    nav.classList.remove('nav-hidden');
  }
  lastY = y;
}, { passive: true });

/* ── Fade-up on scroll ───────────── */
const io = new IntersectionObserver((entries) => {
  entries.forEach(e => {
    if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
  });
}, { threshold: 0.09 });
document.querySelectorAll('.fu').forEach(el => io.observe(el));

/* ── B Bottle video: play on view, loop with 1s pause ── */
const bbVideo = document.querySelector('.b-bottle-video');
if (bbVideo) {
  let bbStarted = false;
  bbVideo.addEventListener('ended', () => {
    setTimeout(() => {
      bbVideo.currentTime = 0;
      bbVideo.play().catch(() => {});
    }, 1000);
  });
  new IntersectionObserver((entries) => {
    entries.forEach(e => {
      if (e.isIntersecting && !bbStarted) {
        bbStarted = true;
        bbVideo.play().catch(() => {});
      }
    });
  }, { threshold: 0.3 }).observe(bbVideo);
}

requestAnimationFrame(() => {
  setTimeout(() => {
    document.querySelectorAll('.hero .fu').forEach(el => el.classList.add('in'));
  }, 60);
});

/* ── Form ────────────────────────── */
const form       = document.getElementById('signup-form');
const emailField = document.getElementById('email-field');
if (form && emailField) {
  const marketingDot   = document.getElementById('marketing-dot');
  const marketingField = document.getElementById('marketing-field');
  const tagsField      = document.getElementById('tags-field');
  const hParam = new URLSearchParams(window.location.search).get('h');
  if (hParam) tagsField.value += ',signed up on: ' + hParam;
  const baseTags       = tagsField.value;

  document.getElementById('marketing-opt').addEventListener('click', () => {
    const on = marketingDot.classList.toggle('checked');
    marketingField.value = on ? 'true' : 'false';
    tagsField.value = on ? baseTags + ',subscribed' : baseTags;
  });

  form.addEventListener('submit', e => {
    const email = emailField.value.trim();
    const valid = email.length > 4 && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    if (!valid) {
      e.preventDefault();
      emailField.classList.add('err');
      emailField.focus();
      emailField.addEventListener('input', () => emailField.classList.remove('err'), { once: true });
    }
  });
}

/* ── Gen 1 expand toggle ────────── */
const gen1Toggle = document.getElementById('gen1-toggle');
const gen1Body   = document.getElementById('gen1-body');
const signupSection = document.getElementById('signup');
if (gen1Toggle && gen1Body) {
  gen1Toggle.addEventListener('click', () => {
    const open = gen1Toggle.classList.toggle('open');
    gen1Body.classList.toggle('open');
    if (signupSection) signupSection.classList.toggle('open');
    gen1Toggle.setAttribute('aria-expanded', open);
    if (open && signupSection) {
      setTimeout(() => signupSection.scrollIntoView({ behavior: 'smooth', block: 'start' }), 300);
    }
  });
}
document.querySelectorAll('a[href="#signup"]').forEach(link => {
  link.addEventListener('click', (e) => {
    e.preventDefault();
    if (signupSection && !signupSection.classList.contains('open')) {
      signupSection.classList.add('open');
      if (gen1Toggle) { gen1Toggle.classList.add('open'); gen1Toggle.setAttribute('aria-expanded', 'true'); }
      if (gen1Body) gen1Body.classList.add('open');
    }
    setTimeout(() => signupSection.scrollIntoView({ behavior: 'smooth', block: 'start' }), 300);
  });
});

/* ── Brand video: play on view ───── */
const brandVid = document.getElementById('brand-vid');
if (brandVid) {
  new IntersectionObserver((entries) => {
    entries.forEach(e => {
      if (e.isIntersecting) brandVid.play().catch(() => {});
      else brandVid.pause();
    });
  }, { threshold: 0.3 }).observe(brandVid);
}
